import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Button, Card, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import api from '../api/api';
import swal from 'sweetalert';
import './CompanyProfile.css';

const CompanyProfile = () => {
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [mobilePhone, setMobilePhone] = useState("");
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const [mySupplier, setMySupplier] = useState({});

    const resetForm = () => {
        if (!mySupplier) return;
        setName(mySupplier.name || "");
        setEmail(mySupplier.email || "");
        setAddress(mySupplier.address || "");
        setMobilePhone(mySupplier.tel_mobile || "");
        setCountry(mySupplier.country || "");
        setCity(mySupplier.city || "");
    }

    const getMySupplierData = async () => {
        await api.get('/supplier/suppliers')
            .then(response => {
                let supplierData = response.data.supplier;
                if (response.data.type === "success") {
                    setMySupplier(supplierData)
                    setName(supplierData.name)
                    setEmail(supplierData.email)
                    setAddress(supplierData.address)
                    setCity(supplierData.city)
                    setCountry(supplierData.country)
                    setMobilePhone(supplierData.tel_mobile)
                }
            }).catch(err => {
                console.error(err)
            })
    }

    useEffect(() => {
        getMySupplierData()
    }, [])

    const editMySupplierData = () => {
        let data = {
            name: name,
            address: address,
            tel_mobile: mobilePhone,
            city: city,
            country: country
        }
        api.post('/supplier/edit-supplier', data)
            .then(response => {
                if (response.data.type === "success") {
                    swal(t('supplier_updated'), {
                        icon: "success",
                    });
                    getMySupplierData()
                }
            }).catch(err => {
                console.error(err)
                swal({
                    icon: 'error',
                    title: t('Oops...'),
                    text: t('Error')
                })
            })
    }

    return (
        <Container fluid className="supplier-company-page py-4">
            <Card className="supco-card">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <h6 className="m-0">{t('supplier_information')}</h6>
                    <div>
                        <Button variant="success" className="mb-2 mr-1" onClick={editMySupplierData}>
                            <i className="fa fa-check mx-2"></i>
                            {t('save')}
                        </Button>
                        <Button variant="outline-primary" className="mb-2 mr-1" onClick={resetForm}>
                            <i className="fa fa-times mx-2"></i>
                            {t('cancel')}
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Form>
                        <Row className="py-4">
                            <Col lg={6} md={12} sm={12}>
                                <Form.Group controlId="name">
                                    <Form.Label>{t('supplier_company_name')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={t('supplier_company_name')}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="email">
                                    <Form.Label>{t('email')}</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder={t('email')}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="tel">
                                    <Form.Label>{t('phone_number')}</Form.Label>
                                    <Form.Control
                                        type="tel"
                                        placeholder={t('phone_number')}
                                        value={mobilePhone}
                                        onChange={(e) => setMobilePhone(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={6} md={12} sm={12}>
                                <Form.Group controlId="Address">
                                    <Form.Label>{t('address')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={t('address')}
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="Country">
                                    <Form.Label>{t('Country')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={t('Country')}
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="City">
                                    <Form.Label>{t('City')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={t('City')}
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    )
}

export default CompanyProfile
